"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSummaryFlow = void 0;
var _react = require("react");
var _useRecommendationStatus = require("../recommendation/useRecommendationStatus");
var _recommendationActions = require("../../store/recommendation/recommendationActions");
var _questionnaireActions = require("../../store/questionnaire/questionnaireActions");
var _widgetSelectors = require("../../store/widget/widgetSelectors");
var _useUserSessionStatus = require("../user/useUserSessionStatus");
var _questionnaireSelectors = require("../../store/questionnaire/questionnaireSelectors");
var _uiActions = require("../../store/ui/uiActions");
var _useAppDispatch = require("../useAppDispatch");
var _useAppSelector = require("../useAppSelector");
const useSummaryFlow = () => {
  var _config$summaryPageDu;
  const dispatch = (0, _useAppDispatch.useAppDispatch)();
  const config = (0, _useAppSelector.useAppSelector)(_widgetSelectors.selectConfig);
  const summaryPageDuration = ((_config$summaryPageDu = config.summaryPageDuration) !== null && _config$summaryPageDu !== void 0 ? _config$summaryPageDu : 4) * 1000;
  const [shouldStartSummaryFlow, setShouldStartSummaryFlow] = (0, _react.useState)(false);
  const [isSummaryFinished, setIsSummaryFinished] = (0, _react.useState)(false);
  const {
    isRecommendationFetched,
    isJourneyForObject,
    isRecommendationEmpty
  } = (0, _useRecommendationStatus.useRecommendationStatus)();
  const {
    isSavingUserSession
  } = (0, _useUserSessionStatus.useUserSessionStatus)();
  const shouldFetchRecommendation = (0, _useAppSelector.useAppSelector)(_questionnaireSelectors.selectIsBudgetAdjusted) || !isRecommendationFetched;
  const shouldEndSummaryFlow = isRecommendationFetched && isSummaryFinished;
  // Step 1:
  // set a flag to start summary flow only after saving user session is finished
  // (from clicking "next" on the previous step)
  (0, _react.useEffect)(() => {
    if (!isSavingUserSession && !shouldStartSummaryFlow) {
      setShouldStartSummaryFlow(true);
    }
  }, [isSavingUserSession]);

  // Step 2:
  // when the summary flow flag is set, fetch the recommendation if needed
  // and start a timer to show the animation.
  (0, _react.useEffect)(() => {
    if (shouldStartSummaryFlow) {
      if (shouldFetchRecommendation) {
        dispatch((0, _recommendationActions.fetchRecommendation)());
      }
      setTimeout(() => {
        setIsSummaryFinished(true);
      }, summaryPageDuration);
    }
  }, [shouldStartSummaryFlow]);

  // Step 3:
  // When both fetching recommendation and animation are finished, signal the end
  // of summary page
  (0, _react.useEffect)(() => {
    if (shouldEndSummaryFlow) {
      if (isRecommendationEmpty) {
        dispatch((0, _uiActions.goToRecommendationErrorPage)(isJourneyForObject));
      } else {
        dispatch((0, _questionnaireActions.endSummary)());
      }
    }
  }, [shouldEndSummaryFlow]);
};
exports.useSummaryFlow = useSummaryFlow;